import React from 'react';
import styled, { css } from 'styled-components';

const Container = styled.div`
  border-bottom: 1px solid #f9f9f9;
  text-align: left !important;
  padding: 0 0 30px 30px;
  margin-bottom: 10px;

  ${props =>
    props.level &&
    css`
      padding-left: ${30 + 40 * props.level}px;
    `}

  @media (max-width: 900px) {
    padding-left: 0;
  }

  > .edit {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
  }

  > .bottom-controls {
    display: flex;
    flex-direction: row;
    > button {
      margin-right: 10px !important;
    }
  }

  > label {
    margin-bottom: 5px !important;
  }

  > h6 {
    color: #939393;
    margin: 0;
  }

  > .MuiInputBase-input-82 .MuiInput-input-67 {
    font-size: 14px !important;
  }
`;

function EditorContainer(props) {
  return <Container level={props.level}>{props.children}</Container>;
}

export default EditorContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorContainer/index.jsx